import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ClientsService } from "../../../routes/services/clients.service";
import { StorageService } from "../../../routes/services/storage.service";
import { FeedersService } from "../../../routes/services/feeder.service";
import { BrandsService } from "../../../routes/Admin/feeders/services/brands.service";
import { DispenserService } from "../../../routes/Admin/feeders/services/dispenser.service";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FarmService } from "../../../routes/services/farm.service";
import { PondService } from "../../../routes/services/pond.service";

@Component({
  selector: "app-modal-feeder-form",
  templateUrl: "./feeder-form.component.html",
  styleUrls: ["./feeder-form.component.scss"]
})
export class FeederFormComponent implements OnInit {
  /** Feeder a editar. Si es undefined se crea uno nuevo. */
  @Input("feeder") feeder: any;

  /** Emite la respuesta del servidor tras una petición exitosa. */
  @Output() successPetition = new EventEmitter();

  feederForm: FormGroup = new FormGroup({
    brand: new FormControl("", Validators.required),
    dispenser: new FormControl("", Validators.required),
    pond: new FormControl("", Validators.required),
    mac: new FormControl("", [
      Validators.required,
      Validators.pattern(`^([0-9a-fA-F]{2}[:-]){7}[0-9a-fA-F]{2}$`)
    ]),
    name: new FormControl("", Validators.required),
    series: new FormControl("", Validators.required),
    client: new FormControl(""),
    filteredBusinessName: new FormControl(""),
    warranty_months: new FormControl(""),
    warranty_start_date: new FormControl("")
  });
  selectFarms: FormGroup = new FormGroup({
    client: new FormControl(""),
    farm: new FormControl("", Validators.required),
    pond: new FormControl("", Validators.required)
  });

  ponds: any = [];
  farms: any = [];
  dispensers: any = [];
  brands: any = [];

  clients = [];
  filteredClients: any = [];

  loadingDispensers = false;
  loadingBrands = false;
  loadingClients = false;
  loadingFarms = false;
  loadingPonds = false;

  constructor(
    public feedersService: FeedersService,
    public brandsService: BrandsService,
    public dispenserService: DispenserService,
    public globalFunction: GlobalFunction,
    public clientsService: ClientsService,
    public storageService: StorageService,
    public farmService: FarmService,
    public pondService: PondService
  ) {}

  ngOnDestroy(): void {
    this.feeder = "";
  }

  ngOnInit(): void {
    this.getClients();
    this.getFeedersDispensers();
    this.getFeedersBrand();
    if (this.feeder) {
      this.setValue(this.feeder);
    }
  }

  /**
   * Precarga los valores del feeder en el formulario.
   * @param value Feeder a editar.
   */
  setValue(value: any): void {
    value.farm && this.getPonds(value.farm.id);
    value.client && this.getFarms(value.client.id);

    this.feederForm.setValue({
      ...this.feederForm.value,
      brand: value.brand ? value.brand.id : "",
      dispenser: value.dispenser ? value.dispenser.id : "",
      pond: value.pond ? value.pond : "",
      mac: this.globalFunction.agregarCaracter(value.mac, ":", 2),
      name: value.name,
      series: value.series,
      client: value.client ? value.client.id : "",
      warranty_months: value.warranty_months ?? "",
      warranty_start_date: value.warranty_start_date ?? ""
    });
    this.selectFarms.setValue({
      farm: value.pond ? value.farm.id : "",
      pond: value.pond ? value.pond.id : "",
      client: value.client ? value.client.id : ""
    });
  }

  /**
   * Envía el formulario para crear o editar un feeder.
   * @param value Valores del feederForm.
   */
  register(value: any): void {
    const { farm, pond } = this.selectFarms.value;
    const { client } = this.feederForm.value;
    const { brand, mac, name, series, dispenser, warranty_months, warranty_start_date } = value;

    const obj: any = { brand, dispenser, mac, name, series, client, pond, farm };
    if (warranty_months !== "" && warranty_months !== null) {
      obj.warranty_months = Number(warranty_months);
    }
    if (warranty_start_date) {
      obj.warranty_start_date = warranty_start_date;
    }

    if (this.feeder) {
      this.feedersService.EditFeeders(this.feeder.id, obj).subscribe(
        (resp: any) => {
          this.successPetition.emit(resp);
        },
        (_err: any) => {}
      );
    } else {
      this.feedersService.PostFeeders(obj).subscribe(
        (resp: any) => {
          this.successPetition.emit(resp);
        },
        (_err: any) => {}
      );
    }
  }

  getFeedersDispensers(): void {
    this.loadingDispensers = true;
    this.dispenserService.listDispensers("").subscribe((resp: any) => {
      this.loadingDispensers = false;
      this.dispensers = resp;
    });
  }

  getFeedersBrand(): void {
    this.loadingBrands = true;
    this.brandsService.listBrands("").subscribe((resp: any) => {
      this.loadingBrands = false;
      this.brands = resp;
    });
  }

  getClients(): void {
    this.loadingClients = true;
    const fields = ["id", "name"];
    this.clientsService.getClients(`?fields=${fields}`).subscribe((resp: any) => {
      this.loadingClients = false;
      this.clients = resp;
      this.filterClientsList();
    });
  }

  filterClientsList(): void {
    const { filteredBusinessName } = this.feederForm.value;
    if (filteredBusinessName) {
      this.filteredClients = this.clients.filter((item: any) =>
        item.name.toLowerCase().indexOf(filteredBusinessName.toLowerCase()) > -1
      );
    } else {
      this.filteredClients = this.clients;
    }
  }

  getFarms(id: any): void {
    if (id) {
      this.loadingFarms = true;
      const fields = ["id", "name"];
      const query_client = id ? `&client=${id}` : "";
      this.farmService.getFarms(`?fields=${fields}${query_client}`).subscribe((resp: any) => {
        this.loadingFarms = false;
        this.feederForm.setValue({ ...this.feederForm.value, client: id });
        this.farms = resp;
      });
    } else {
      this.farms = [];
      this.selectFarms.controls["pond"].setValue("");
      this.selectFarms.controls["farm"].setValue("");
    }
  }

  getPonds = async (farm_id: any) => {
    if (farm_id) {
      this.loadingPonds = true;
      try {
        const fields = ["id", "name"];
        const { alert_query, name_query } = this.storageService.getQueryFilters({
          alert_query: "",
          name_query: ""
        });
        const alert = alert_query ? `-alert_count,` : "";
        const name = name_query ? `name_advance` : "number";
        const object_query = { farm_id, fields, ordering: alert + name, all_records: "true" };
        const query = this.globalFunction.constructQuery(object_query);
        const data = await this.pondService.getPonds(query).toPromise();
        this.loadingPonds = false;
        this.ponds = data;
        this.selectFarms.setValue({ ...this.selectFarms.value, farm: farm_id });
      } catch (_error) {}
    }
  };
}
